










































































import { Component, Vue, Prop } from "vue-property-decorator";
import DetalheAtendimentoModel from "@/models/cadastros/saude/DetalheAtendimentoModel";
import { saudeAtendimentoService } from "@/service/cadastro/saude/atendimento/SaudeAtendimentoService";
import JsZip from 'jszip';

@Component
export default class DadosGlosa extends Vue {
  @Prop()
  readonly detalhe!: DetalheAtendimentoModel;

  loadingDowload = false

  downloadComprovantes(arquivos: string[]) {
    if (!!arquivos?.length) {
      this.loadingDowload = true;
      const zip = new JsZip();
      arquivos.forEach((file, i) => {
        saudeAtendimentoService
          .obterDocumentosValorAdicional(file)
          .then((res: Blob) => {
            const type = res.type.split('/');
            zip.file(`comprovante_${i+1}.${type[type.length-1]}`, res);
            if (i == arquivos.length-1) {
              zip.generateAsync({type:"blob"})
                .then((content: Blob) => {
                  const downloadUrl = window.URL.createObjectURL(content);
                  const link = document.createElement("a");
                  link.href = downloadUrl;
                  link.setAttribute("download", 'comprovantesIntercorrencia.zip');
                  document.body.appendChild(link);
                  link.click();
                  link.remove();
                  this.loadingDowload = false;
                });
            }
          })
          .catch((err) => {
            this.loadingDowload = false;
          });
      });
    }
  }
}
